document.addEventListener("DOMContentLoaded", function () {

    const widget = document.querySelector(".add-to-calendar__btn");
    if (!widget) return;

    const btn = widget.querySelector(".atc-btn");
    const data = widget.dataset;

    if (!btn || !data.start || !data.end) return;

    // Toggle menu
    btn.addEventListener("click", (e) => {
        e.stopPropagation();
        widget.classList.toggle("show");
    });

    // Convert ISO with timezone → Google Calendar UTC Z
    function toGoogleDate(isoString) {
        const dt = new Date(isoString);
        return dt.toISOString().replace(/[-:]/g, "").replace(".000", "");
    }

    const startGoogle = toGoogleDate(data.start);
    const endGoogle   = toGoogleDate(data.end);

    const googleUrl =
        "https://calendar.google.com/calendar/render?action=TEMPLATE" +
        "&text=" + encodeURIComponent(data.title || "") +
        "&details=" + encodeURIComponent(data.description || "") +
        "&location=" + encodeURIComponent(data.location || "") +
        "&dates=" + startGoogle + "/" + endGoogle;

    const addGoogle = widget.querySelector(".add-google");
    if (addGoogle) addGoogle.href = googleUrl;

    const icsContent =
        "BEGIN:VCALENDAR\n" +
        "VERSION:2.0\n" +
        "BEGIN:VEVENT\n" +
        "SUMMARY:" + (data.title || "").replace(/\n/g, "\\n") + "\n" +
        "DESCRIPTION:" + (data.description || "").replace(/\n/g, "\\n") + "\n" +
        "LOCATION:" + (data.location || "").replace(/\n/g, "\\n") + "\n" +
        "DTSTART:" + (data.start || "").replace(/[-:]/g, "").replace(".000", "") + "\n" +
        "DTEND:" + (data.end || "").replace(/[-:]/g, "").replace(".000", "") + "\n" +
        "END:VEVENT\n" +
        "END:VCALENDAR";

    const icsBlob = new Blob([icsContent], { type: "text/calendar" });
    const icsUrl = URL.createObjectURL(icsBlob);

    const addOutlook = widget.querySelector(".add-outlook");
    const addApple = widget.querySelector(".add-apple");
    if (addOutlook) addOutlook.href = icsUrl;
    if (addApple) addApple.href = icsUrl;

    document.addEventListener("click", (e) => {
        if (!widget.contains(e.target)) {
            widget.classList.remove("show");
        }
    });

    document.addEventListener("keydown", (e) => {
        if (e.key === "Escape") {
            widget.classList.remove("show");
        }
    });
});
